import { NgModule } from "@angular/core";
import { AuthGuardService } from "app/shared/auth-guard.service";
import { canDeactivateGuard } from "app/shared/can-deactivate-guard.service";
import { EntityManagerProviderGuard } from "app/shared/entity-manager-guard";
import { SharedModule } from "app/shared/shared.module";
import { GridsterModule } from "angular-gridster2";
import { ChartInvoiceDelayComponent } from "./chart-invoice-delay.component";
import { ChartInvoiceStatsComponent } from "./chart-invoice-stats.component";
import { ChartJoStatsComponent } from "./chart-jo-stats.component";
import { ChartManufInventoryComponent } from "./chart-manuf-inventory.component";
import { ChartsContainerComponent } from "./charts-container.component";
import { EntityIssueComponent } from "./entity-issue.component";
import { HomeComponent } from "./home.component";
import { InProcessComponent } from "./in-process.component";
import { JoStatsDialogComponent } from "./jo-stats-dialog.component";
import { ProximityApiComponent } from "./proximity-api.component";
import { ReferencesComponent } from "./references.component";
import { QbSubmissionComponent } from "./qb-submission.component";
import { DashboardContainerComponent } from "./dashboard/dashboard-container.component";
import { WidgetPickerDialogComponent } from "./dashboard/widgets/widget-picker-dialog.component";
import { JoInProcessWidgetComponent } from "./dashboard/widgets/jo-in-process-widget.component";
import { WidgetDataDialogComponent } from "./dashboard/widgets/widget-data-dialog.component";
import { ChartProductTypeInventoryComponent } from "./dashboard/widgets/chart-product-type-inventory.component";
import { ChartAccountFulfillmentTimeComponent } from "./dashboard/widgets/chart-account-fulfillment-time.component";
import { ChartManufacturerReceiptTimeComponent } from "./dashboard/widgets/chart-manufacturer-receipt-time.component";
import { AccountOverdueOrdersComponent } from "./dashboard/widgets/account-overdue-orders.component";
import { ChartWeeklyShipmentRevenueComponent } from "./dashboard/widgets/chart-weekly-shipment-revenue.component";
import { RedZoneComponent } from "./dashboard/widgets/red-zone.component";
import { OnTimeShippedKpiComponent } from "./dashboard/widgets/on-time-shipped-kpi.component";
import { OrdersShippedCompleteKpiComponent } from "./dashboard/widgets/orders-shipped-complete-kpi.component";
import { ProcessStationUnitsKpiComponent } from "./dashboard/widgets/process-station-units-kpi.component";
import { ExcludedAccountsDialogComponent } from "./dashboard/excluded-accounts-dialog.component";

export const routes = [
  {
    path: "home",
    component: DashboardContainerComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
    canDeactivate: [canDeactivateGuard],
    data: {
      icon: "dashboard",
    },
  },
  {
    path: "in-process",
    component: InProcessComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
  },
  {
    path: "entity-issue",
    component: EntityIssueComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
    canDeactivate: [canDeactivateGuard],
    data: {
      icon: "report_problem",
    },
  },
  {
    path: "charts-container",
    component: ChartsContainerComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
    canDeactivate: [canDeactivateGuard],
    data: {
      icon: "pie_chart",
    },
  },
  {
    path: "dashboard",
    component: DashboardContainerComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
    canDeactivate: [canDeactivateGuard],
    data: {
      icon: "dashboard",
    },
  },
];

@NgModule({
  declarations: [
    HomeComponent,
    ReferencesComponent,
    InProcessComponent,
    EntityIssueComponent,
    QbSubmissionComponent,
    ChartInvoiceDelayComponent,
    ChartInvoiceStatsComponent,
    ChartManufInventoryComponent,
    ChartJoStatsComponent,
    ChartsContainerComponent,
    JoStatsDialogComponent,
    ProximityApiComponent,
    DashboardContainerComponent,
    WidgetPickerDialogComponent,
    JoInProcessWidgetComponent,
    WidgetDataDialogComponent,
    ChartProductTypeInventoryComponent,
    ChartAccountFulfillmentTimeComponent,
    ChartManufacturerReceiptTimeComponent,
    AccountOverdueOrdersComponent,
    ChartWeeklyShipmentRevenueComponent,
    RedZoneComponent,
    OnTimeShippedKpiComponent,
    OrdersShippedCompleteKpiComponent,
    ProcessStationUnitsKpiComponent,
    ExcludedAccountsDialogComponent,
  ],
  imports: [SharedModule, GridsterModule],
  exports: [
    // HomeComponent,
    // EntityIssueComponent
  ],
})
export class HomeModule { }
